import IndicatorDetail from './IndicatorDetail'

export default IndicatorDetail



// WEBPACK FOOTER //
// ./src/pages/IndicatorDetail/index.js